import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/tip-pool-calculator',
  component: () => import('../../routes/TipPoolCalculator.svelte'),
  card: {
    id: 'tip-pool-calculator',
    title: 'Tip Pool Calculator',
    description: 'Calculate tip pool distribution between front-of-house and back-of-house staff based on hours worked.',
    icon: 'dining',
    iconBgClass: 'bg-amber-50',
    iconTextClass: 'text-amber-600',
    href: '/tip-pool-calculator',
    category: 'Business',
  },
  seo: {
    title: 'Tip Pool Calculator – Fair Tip Distribution Calculator',
    description: 'Free tip pool calculator to fairly distribute tips between front-of-house and back-of-house staff based on hours worked. Calculate tip-out percentages and per-person shares instantly.',
  },
};

export default meta;
